import React, { Component } from 'react';
import PropTypes from "prop-types";
import DatePicker, {registerLocale}  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';


class VehiculeInfoComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
        }
        registerLocale('fr', fr);
        this.handleChange = this.handleChange.bind(this);
        this.handleOptionUsageChange = this.handleOptionUsageChange.bind(this);
       
    }

    componentDidMount() {
        
    }


    handleOptionUsageChange = changeEvent => {
      this.props.handleOptionUsageChange(changeEvent);
    };

    handleChange = (e) =>{
      this.props.handleChange(e);
    };

    handleDateMECChange = date => {

      this.props.handleDateMECChange(date);

    };



    render() {

        return (
            <React.Fragment>
              <div class="row mt-3 py-3">
                <div class="col-md-6">
                  <form id="c_form-h" >
                  <div class="form-group row">
                  <label for="divusages" class="col-4 col-form-label">Usage risque</label>
                  <div class="col-8">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons" id = "divusages">
                    <label class="btn btn-outline-success active">
                        <input type="radio" value = "A1" name="options" id="hatchback" autoComplete="off" checked={this.props.usage === "A1"} onChange={this.handleOptionUsageChange}/> 
                        <i class="fa fa-fw fa-car"></i>Voiture
                    </label>

                    <label class="btn btn-outline-success disabled">
                    <input type="radio"  value = "D1" name="options" id="sedan" autoComplete="off" checked={this.props.usage === "D1"} onChange={this.handleOptionUsageChange}/> 
                    <i class="fa fa-fw fa-motorcycle"></i>Moto
                    </label>

                    <label class="btn btn-outline-success disabled">
                    <input type="radio" value = "C1" name="options" id="suv" autoComplete="off" checked={this.props.usage === "C1"} onChange={this.handleOptionUsageChange}/> 
                    <i class="fa fa-fw fa-truck"></i>Camion
                    </label>
                    </div>
                    </div>
                  </div> 
                    <div class="form-group row"> <label for="energie" class="col-4 col-form-label">Energie</label>
                      <div class="col-8">
                        <select class="form-control" id="energie" name="energie" value={this.props.energie} onChange={this.handleChange}>
                            <option value="">---Energie---</option>
                            <option value = "E">Essence</option>
                            <option value = "D">Diesel</option>
                            <option value = "H">Hybride</option>
                            <option value = "T">Electrique</option>
                        </select>
                        </div>
                    </div>
                    <div class="form-group row"> <label for="puissanceFiscale" class="col-4 col-form-label">Puissance</label>
                      <div class="col-8">
                        <input type="text" class="form-control" id="puissanceFiscale" name = "puissanceFiscale" placeholder="Puissance" value={this.props.puissanceFiscale} onChange={this.handleChange}/> 
                        </div>
                    </div>
                    <div class="form-group row"> <label for="dateMECForm" class="col-4 col-form-label">Date MEC</label>
                      <div class="col-8">
                      <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="dateMECForm" id="dateMECForm" placeholderText="date de MEC" selected={this.props.dateMEC}  onChange={this.handleDateMECChange}/>
                        </div>
                    </div>

                  </form>
                </div>
                <div class="col-md-6">
                  <form id="c_form-h" >
                    <div class="form-group row"> <label for="valeurNeuf" class="col-4 col-form-label">Valeur à Neuf</label>
                      <div class="col-8">
                        <input type="text" class="form-control" id="valeurNeuf" name="valeurNeuf" placeholder="valeur à neuf" value={this.props.valeurNeuf} onChange={this.handleChange}/> </div>
                    </div>
                    <div class="form-group row"> <label for="valeurVenale" class="col-4 col-form-label">Valeur vénale</label>
                      <div class="col-8">
                        <input type="text" class="form-control" id="valeurVenale" name="valeurVenale" placeholder="valeur vénale" value={this.props.valeurVenale} onChange={this.handleChange}/> </div>
                    </div>
                    <div class="form-group row"> <label for="valeurGlaces" class="col-4 col-form-label">Valeur des glaces</label>
                      <div class="col-8">
                        <input type="text" class="form-control" id="valeurGlaces" name="valeurGlaces" placeholder="capital glaces" value={this.props.valeurGlaces} onChange={this.handleChange}/> </div>
                    </div>
                   
                  </form>
                </div>
              </div>
              
          </React.Fragment>

        );
    }

}

VehiculeInfoComponent.propTypes = {
  handleOptionUsageChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleDateMECChange: PropTypes.func.isRequired
};

export default VehiculeInfoComponent;